import React, { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import DelayedFallback from '@app/DelayedFallback'
import { Loader } from '@/components/Loader'

const PublicLayout = () => {
	return (
		<div style={{ minHeight: '100vh' }}>
			<Suspense
				fallback={
					<DelayedFallback delay={300}>
						<div style={{ padding: 24 }}>
							<Loader />
						</div>
					</DelayedFallback>
				}
			>
				<Outlet />
			</Suspense>
		</div>
	)
}

export default PublicLayout
